import {Injectable, inject} from '@angular/core'
import {EmbeddedStoreService} from '@service/embeddingService/embedded-store.service'
import {OrderLineService} from './orderLine.service'

/**
 * Variante embebida de `OrderLineService`.
 *
 * @description
 * Lee los tipos de línea desde `EmbeddedStoreService.allOrderLines()` (precargados por el
 * host) en lugar de PouchDB.
 */
@Injectable({
  providedIn: 'root',
})
export class OrderLinesEmbeddedService extends OrderLineService {
  private readonly orderEmbeddedService: EmbeddedStoreService = inject(EmbeddedStoreService)
  protected override getItemOrderLines = async (): Promise<any> => {
    return this.orderEmbeddedService.allOrderLines()
  }
}
